//@flow
import * as Immutable from 'immutable';

import NumberUtils from 'common/utils/NumberUtils';
import { ContractCostFunction } from 'common/models/flow/ContractCostFunction';
import type { ContractCostFunctionModelType } from 'common/models/flow/ContractCostFunction';

import { VehicleModelId } from './VehicleModelId';
import { RiderPersonaId } from './RiderPersonaId';
import { CostFunction } from './CostFunction';

class InternalContractCostFunction extends ContractCostFunction {
    static fromJS(
        json: ContractCostFunctionModelType
    ): InternalContractCostFunction {
        const state: Object = Object.assign({}, json);
        state.vehicleModelIds = Immutable.List(
            state.vehicleModelIds
        ).map(item => VehicleModelId.fromJS(item));
        state.riderPersonaIds = Immutable.List(
            state.riderPersonaIds
        ).map(item => RiderPersonaId.fromJS(item));
        state.costFunction = CostFunction.fromJS(state.costFunction);
        return new this(Immutable.Map(state));
    }

    get vehicleModelIds(): Immutable.List<VehicleModelId> {
        return this._state.get('vehicleModelIds');
    }

    get costFunction(): CostFunction {
        return this._state.get('costFunction');
    }

    get riderPersonaIds(): Immutable.List<RiderPersonaId> {
        return this._state.get('riderPersonaIds');
    }

    static defaultInit(): InternalContractCostFunction {
        return InternalContractCostFunction.fromJS({
            id: NumberUtils.guid(),
            costFunction: {
                costExpression: {
                    costComponents: [
                        {
                            parameter: {
                                parameterType: '',
                                uniqueType: null,
                                filterOn: 'NONE',
                                operator: null
                            },
                            unit: '',
                            weightSteps: {
                                steps: []
                            },
                            weightType: null,
                            cost: '',
                            condition: null
                        }
                    ],
                    operator: null
                },
                currency: null,
                id: null,
                symbol: null
            },
            vehicleModelIds: [],
            riderPersonaIds: []
        });
    }
}

export { InternalContractCostFunction as ContractCostFunction };
